import { render, staticRenderFns } from "./ElStarRating.vue?vue&type=template&id=66961708"
import script from "./ElStarRating.vue?vue&type=script&lang=js"
export * from "./ElStarRating.vue?vue&type=script&lang=js"
import style0 from "./ElStarRating.vue?vue&type=style&index=0&id=66961708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports